import { useEffect, useState, useCallback, createContext, useContext } from 'react';
import ToastContainer from '@/Components/Containers/ContainerToast';

const ToastContext = createContext();

export function ToastContextProvider({ children }) {

    const [toasts, setToasts] = useState([])

    useEffect(() => {
        if(setToasts.length > 0) {
            const timer = setTimeout(
                () => setToasts(toasts => toasts.slice(1)),
                3000
            )
            return () => clearTimeout(timer)
        }
    }, [toasts]);

    const addToast = useCallback(content => {
        setToasts(toasts => [
            ...toasts,
            { id: (Date.now()).toString(36), content: content.message, variant: content.variant }
        ])
    }, [setToasts])

    const removeToast = useCallback(id => {
        setToasts(toasts => toasts.filter(t => t.id !== id));
    }, [setToasts]);

    return (
        <ToastContext.Provider value={{addToast, removeToast}}>
            <ToastContainer toasts={toasts} />
            {children}
        </ToastContext.Provider>
    )
}

export default function useToastContext() {
    return useContext(ToastContext)
}

export const useToasts = () => {
    const ctx = useContext(ToastContext)

    return {
        addToast: ctx.addToast,
        removeToast: ctx.removeToast
    }
}